const attr = {
  state: () => ({
    attrList: [],
    // attrList: [
    //   {
    //     groupId: 1,
    //     groupName: "电气参数",
    //     checkAll: true,
    //     isIndeterminate: false,
    //     checkedAttrs: [],
    //     propertiesList: [
    //       {
    //         id: 1,
    //         name: "上海1"
    //       },
    //       {
    //         id: 2,
    //         name: "北京1"
    //       },
    //       {
    //         id: 3,
    //         name: "广州1"
    //       },
    //       {
    //         id: 4,
    //         name: "深圳1"
    //       }
    //     ]
    //   },
    //   {
    //     groupId: 2,
    //     groupName: "结构参数",
    //     checkAll: false,
    //     isIndeterminate: false,
    //     checkedAttrs: [],
    //     propertiesList: [
    //       {
    //         id: 21,
    //         name: "上海2"
    //       },
    //       {
    //         id: 22,
    //         name: "北京2"
    //       },
    //       {
    //         id: 23,
    //         name: "广州2"
    //       },
    //       {
    //         id: 24,
    //         name: "深圳2"
    //       }
    //     ]
    //   },
    //   {
    //     groupId: 3,
    //     groupName: "图片参数",
    //     checkAll: false,
    //     isIndeterminate: false,
    //     checkedAttrs: [],
    //     propertiesList: [
    //       {
    //         id: 31,
    //         name: "上海3"
    //       },
    //       {
    //         id: 32,
    //         name: "北京3"
    //       },
    //       {
    //         id: 33,
    //         name: "广州3"
    //       },
    //       {
    //         id: 34,
    //         name: "深圳3"
    //       }
    //     ]
    //   },
    //   {
    //     groupId: 4,
    //     groupName: "环境参数",
    //     checkAll: true,
    //     isIndeterminate: false,
    //     checkedAttrs: ["上海4", "北京4"],
    //     propertiesList: [
    //       {
    //         id: 41,
    //         name: "上海4"
    //       },
    //       {
    //         id: 42,
    //         name: "北京4"
    //       },
    //       {
    //         id: 43,
    //         name: "广州4"
    //       },
    //       {
    //         id: 44,
    //         name: "深圳4"
    //       }
    //     ]
    //   }
    // ]
  }),
  mutations: {
    SET_ATTR_LIST: (state, attrList) => {
      state.attrList = attrList;
    },
    UPDATE_ATTR: (state, { attr, index }) => {
      console.log("UPDATE_ATTR", attr, index);
      let attrList = state.attrList;
      attrList[index] = attr;
      state.attrList = attrList;
    }
  }
};

export default attr;



// WEBPACK FOOTER //
// ./src/store/modules/attr.js